import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

export function TopBar({ title, onBack, action, onAction, actionPressed }: { title: string; onBack: () => void; action?: IconName; onAction?: () => void; actionPressed?: boolean }) {
  return (
    <header className="top-bar">
      <button type="button" className="icon-button" onClick={onBack} aria-label="Go back"><Icon name="back" size={30} /></button>
      <strong>{title}</strong>
      {action ? <button type="button" className="icon-button" onClick={onAction} aria-label={action === "bookmark" ? "Save story" : "Share"} aria-pressed={actionPressed}><Icon name={action} size={28} /></button> : <span className="top-bar__spacer" />}
    </header>
  );
}
